








    import { Vue, Component, Mixins } from "vue-property-decorator";
	import { Controller } from "@/plugins/Controller";
    import BaseComponent from "@/plugins/BaseComponent";
    import { MenuItem } from "@/models/MenuItem";

    import MenuItemControl from "@/components/MenuItem.vue";

	@Component({
		components: {
		    MenuItemControl,
		}
	})
    export default class MainMenu extends Mixins(BaseComponent){

	    private controller: Controller = new Controller();
	    private items: MenuItem[] = [];

	    mounted(){
	        this.showLoader()
	        this.controller.GetEntry(this.MENU_ID)
				.then(this.gotMenu);
	    }

		gotMenu(response: any){
	        this.hideLoader();
	        this.items = JSON.parse(response.data.value.MenuContent);
		}
	}

